import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';
import FormGroup from 'jd-library/FormGroup';
import FormFeedBack from 'jd-library/FormFeedBack';
import FormLabel from 'jd-library/FormLabel';
import InputGroup from 'jd-library/InputGroup';
import Button from 'jd-library/Button';
import axios from 'axios';
import {setLoggedUser} from '../../actions/index';
import {setAuditObject} from '../../actions/products';
import {fetchAuditUrl,logOut} from '../../utills';
import {auditorDomain} from '../../../config/config'; 
import "./audi_login.scss";

const sendOtp = (options = {}) => {
	let { userName, companyName, cb, token} = options;
	let type = 'mobile';
	if(isNaN(userName)) {
		type = 'email';
	}
	axios.get(`/vendor/manage-products-genio/${token}/api/sendOtp.ns?isAuditor=${true}&type=${type}`, {
		headers: {
			'userName': userName
		}
	}).then((data) => {
		cb && cb(data);
	});
};

const verifyOtp = (options = {}) => {
	let {otp, cb, token} = options;
	if(isNaN(otp) || otp.length != 4){
		cb && cb({
			data: {
				isSuccess: false
			}
		})
		return;
	}
	axios.post(`/vendor/manage-products-genio/${token}/api/verifyOtp.ns`,{otpValue: otp}).then((data) => {
		cb && cb(data);
	});
};

const AudiLogin = props => {
	let [pageState, updatePageState] = useState('username');
	let [fieldValue, updateFieldValue] = useState('');
	let [buttonLoader, updateButtonLoader] = useState(false);
	let [audiBtnLoader,updateAudiBtnLoader] = useState(false);
	let [showError, updateError] = useState(false);
	let [loggedIn, updateLoggedIn] = useState(false);
	const [isCorrector, setIsCorrector] = useState(false)
	let auditHomePath = "/audit-home";
	if(typeof window !== 'undefined' && window.top != window.self) {
		auditHomePath += '?loadedInIframe=true';
	}
	let history = useHistory();
	useEffect(() => {
		if(window.onfocus) {
			window.onfocus = undefined;
		}
		const host = window.location.host;
		if(auditorDomain.indexOf(host) == -1) {
			if(window.parent && window.parent.location) {
				window.parent.location.href = `${auditorDomain}${window.location.pathname}`;
			} else {
				window.location.href = `${auditorDomain}${window.location.pathname}${window.top != window.self ? "?loadedInIframe=true": '' }`;
			}
		}
	},[]);
	useEffect(() => {
		if(props.session.user.loggedUser && props.session.user.loggedUser.userType == 'AUDITOR'){
			if(props.session.user.loggedUser?.subType == 'CORRECTOR'){
				setIsCorrector(true)
			}
			// updateLoggedIn(true);
			history.push(auditHomePath);
		} else {
			setIsCorrector(false)
		}
	},[props.session.user.loggedUser]);

	const otpSendVerify = () => {
    updateButtonLoader(true);
    if (pageState == "username") {
      sendOtp({
        updatePageState,
        token: props.session.token,
        companyName: props.session.companyName,
        userName: fieldValue,
        cb: (data) => {
          if (data.data.isSuccess) {
            updateFieldValue("");
            updatePageState("otp");
          } else {
            updateError(true);
          }
          updateButtonLoader(false);
        },
      });
    } else {
      verifyOtp({
        otp: fieldValue,
        token: props.session.token,
        cb: (data) => {
          if (
            data.data.isSuccess &&
            data.data?.prodCrudData?.token &&
            props.session.token &&
            data.data?.prodCrudData?.token == props.session.token
          ) {
            props.setLoggedUser(data.data.prodCrudData);
            if (props.auditData.redirectUrl) {
              let url = props.auditData.redirectUrl;
              props.setAuditObject({
                redirectUrl: "",
              });
              // history.push(url);
              window.location.href = url;
            } else {
              updateLoggedIn(true);
              history.push(auditHomePath);
            }
          } else {
            updateError(true);
          }
          updateButtonLoader(false);
        },
      });
    }
  };
  
	return (<div className = {'login-page'}>
		<div className = {'holder'}>
			{
				loggedIn ? <>
					<div className = {'logged-in-header'}>
						{`${isCorrector ? 'Correct' : 'Audit'} Products`}
					</div>
					<div className = {'logged-in-text'}>
						{`You can click on Start ${isCorrector ? 'Correcting' : 'Auditing'} Now button to ${isCorrector ? 'correct' : 'audit'} product.`}
					</div>
					<Button 
						className = {'action-btn'}
						showLoader = {audiBtnLoader}
						size="lg"
						clickHandler = {() => {
							updateAudiBtnLoader(true);
							fetchAuditUrl({
								cb: (data) => {
									if(data.data.status == 1) {
										if(window.top != window.self) {
											data.data.url += '&loadedInIframe=true';
										}
										window.location.href = data.data.url;
									} else {
										alert("No Products Found.");
									}
									updateAudiBtnLoader(false);
								}
							});
						}}
						>{`Start ${isCorrector ? 'Correcting' : 'Auditing'} Now`}</Button>
					<Button
						className = {'action-btn'}
						showLoader = {buttonLoader}
						size="lg"
						variant="default"
						clickHandler = {() => {
							logOut({
								token: props.session.token,
								cb: (data) => {
									if(data.data.isSuccess){
										updateLoggedIn(false);
										updateFieldValue('');
										updatePageState('username');
										props.setLoggedUser(null)
									} else {
										console.log('unable to logout');
									}
								}
							});
						}}
					>Log Out</Button>
				</> 
				: <>
				<FormGroup>
					<FormLabel>{pageState == 'username' ? 'Enter Username' : 'Enter OTP'}</FormLabel>
					<InputGroup input={
							{placeHolder: (pageState == 'username' ? 'Email / Mobile No.' : 'Four Digit OTP'),
								onKeyDown: e => {if (e.key == 'Enter'){otpSendVerify()}},
								onChange: (e) => {
									updateFieldValue(e.target.value);
									updateError(false);
								}, 
								value: fieldValue
							}
							}/>
					{ showError ? <FormFeedBack variant='invalid'>{pageState == 'username' ? 'Invalid Username' : 'Invalid OTP'}</FormFeedBack> : null}
				</FormGroup>
				<Button 
					className = {'action-btn'}
					showLoader = {buttonLoader}
					clickHandler = {otpSendVerify}
				>{pageState == 'username' ? 'SEND OTP' : 'VERIFY OTP'}</Button>
				</>
			}
		</div>
	</div>);
};

const mapStateToProps = state => {
	return {
		session: state.session,
		auditData: state.products.auditData,
		deviceData: state.deviceData
	};
};

export default connect(mapStateToProps,{setLoggedUser,setAuditObject})(AudiLogin);